import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
//import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
//import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase } from 'lodash';
import { formatMoney } from "../libs/myUtils";
import { myListSciHackFiles } from '../graphql/my.queries';
//import RangeSlider from 'react-bootstrap-range-slider';



// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Description, FileName, TriggerPayout, TriggerLevel, TriggerCondition, 
    ProjectionPeriods, RiskLoading) => {
  const [description, setDescription] = useState(Description);
  const [fileName, setFileName] = useState(FileName);
  const [triggerPayout, setTriggerPayout] = useState(TriggerPayout);
  const [triggerLevel, setTriggerLevel] = useState(TriggerLevel);
  const [triggerCondition, setTriggerCondition] = useState(TriggerCondition);
  const [projectionPeriods, setProjectionPeriods] = useState(ProjectionPeriods);
  const [riskLoading, setRiskLoading] = useState(RiskLoading);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'SciHackRestApi';
  const path = '/price';
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      description: description,
      fileName: fileName,
      triggerPayout: triggerPayout,
      triggerLevel: triggerLevel,
      triggerCondition: triggerCondition,
      projectionPeriods: projectionPeriods,
      riskLoading: riskLoading
    }
  };
  //console.log(myInit);

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));

        // reformat response.data.output to columns
        var date_arr = [];
        var mean_arr = [];
        var min_arr = [];
        var median_arr = [];
        var pctle5_arr = [];
        var max_arr = [];
        var pctle95_arr = [];
        var disc_factor_arr = [];
        var loaded_premium_arr = [];
        var pure_premium_arr = [];

        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.date);
          mean_arr.push(item.mean);
          min_arr.push(item.min);
          median_arr.push(item.median);
          pctle5_arr.push(item.pctle5);
          pctle95_arr.push(item.pctle95);
          max_arr.push(item.max);
          disc_factor_arr.push(item.disc_factor);
          loaded_premium_arr.push(item.loaded_premium);
          pure_premium_arr.push(item.pure_premium);
        });

        var pure_premium = Number.parseFloat(response.data.pure_premium);
        var loaded_premium = Number.parseFloat(response.data.loaded_premium);
        var disc_rate = response.data.disc_rate;
        var risk_loading = response.data.risk_loading;

        //console.log('date: ' + date_arr);
        //console.log('pure_premium_arr: ' + pure_premium_arr);
        //console.log('pure_premium: ' + pure_premium);
        //console.log('loaded_premium: ' + response.data.loaded_premium)
        //console.log('loading: ' + response.data.loading);

        setDataCols({'Date': date_arr, 'Mean': mean_arr, 'Min': min_arr, 'Median': median_arr, 'Pctle5': pctle5_arr, 'Pctle95': pctle95_arr,
          'Max': max_arr, 'DiscountFactor': disc_factor_arr, 'LoadedPremiumArr': loaded_premium_arr, 'PurePremiumArr': pure_premium_arr,
          'LoadedPremium': loaded_premium, 'PurePremium': pure_premium, 'DiscountRate': disc_rate, 'Loading': risk_loading
        });

      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (description !== "" && fileName !== "" && triggerPayout !== "" && triggerLevel !== "" && triggerCondition !== ""
      && projectionPeriods !== "" && riskLoading !== "")  {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [description, fileName, triggerPayout, triggerLevel, triggerCondition, projectionPeriods, riskLoading]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setDescription, setFileName, setTriggerPayout, 
    setTriggerLevel, setTriggerCondition, setProjectionPeriods, setRiskLoading];
};


export default function Price() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileName, setFileName] = useState('sunshine-duration-monthly-mean-daily-duration.csv');
  const [triggerPayout, setTriggerPayout] = useState("");
  const [triggerCondition, setTriggerCondition] = useState("");
  const [triggerLevel, setTriggerLevel] = useState("");
  const [projectionPeriods, setProjectionPeriods] = useState("");
  const [riskLoading, setRiskLoading] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(true);
  const [triggerPayoutSelected, setTriggerPayoutSelected] = useState(false);
  const [triggerConditionSelected, setTriggerConditionSelected] = useState(false);
  const [triggerLevelSelected, setTriggerLevelSelected] = useState(false);
  const [projectionPeriodsSelected, setProjectionPeriodsSelected] = useState(false);
  const [riskLoadingSelected, setRiskLoadingSelected] = useState(false);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState('hours')

  const [{ dataCols, dataRows, isComputing, isError }, 
    setDescriptionArg, setFileNameArg, setTriggerPayoutArg, setTriggerLevelArg, setTriggerConditionArg, 
    setProjectionPeriodsArg, setRiskLoadingArg] = useRestApi(
      description, fileName, triggerPayout, triggerLevel, triggerCondition, projectionPeriods, riskLoading);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        let filter = {
          fileType: {
              eq: 'csv'
          }
        };
        const apiData = await API.graphql({ query: myListSciHackFiles, variables: { filter: filter} });
        const tsFromApi = apiData.data.listSciHackFiles.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listSciHackFiles.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.description}|${value.fileType}|${value.fileName}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
        setFileName(timeSeriesParams[1]);
        break;
      case "selectTriggerPayout":
        //setRiskDriver(event.target.value);
        setTriggerPayoutSelected(true);
        break;
      case "selectTriggerCondition":
        setTriggerConditionSelected(true);
        break;
      case "selectTriggerLevel":
        setTriggerLevelSelected(true);
        break;
     case "selectProjectionPeriods":
        setProjectionPeriodsSelected(true);
        break;
    case "selectRiskLoading":
        setRiskLoadingSelected(true);
        break;
    default:
        console.log("No input change.");
        break;
    }
    //console.log("Input changed: " + event.target.id + " - " + event.target.value);
    //console.log("Input changed: " + event.target.id + " - " + document.getElementById('selectTimeSeries').value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected) && (triggerPayoutSelected) && (triggerConditionSelected) && 
        (triggerLevelSelected) && (projectionPeriodsSelected) && (riskLoadingSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setDescription(timeSeriesParams[0]);
    setDescriptionArg(timeSeriesParams[0]);
    setFileName(timeSeriesParams[1]);
    setFileNameArg(timeSeriesParams[1]);
    if (timeSeriesParams[1] === "sunshine-duration-monthly-mean-daily-duration.csv") {
      setUnitOfMeasurement('hours');
    } else if (timeSeriesParams[1] === "surface-air-temperature-monthly-mean.csv") {
      setUnitOfMeasurement('degrees');
    } else if (timeSeriesParams[1] === "rainfall-monthly-total.csv") {
      setUnitOfMeasurement('mm');
    } else if (timeSeriesParams[1] === "rainfall-monthly-number-of-rain-days.csv") {
      setUnitOfMeasurement('days');
    }

    setTriggerPayout(document.getElementById('selectTriggerPayout').value);
    setTriggerPayoutArg(document.getElementById('selectTriggerPayout').value);
    setTriggerCondition(document.getElementById('selectTriggerCondition').value);
    setTriggerConditionArg(document.getElementById('selectTriggerCondition').value);
    setTriggerLevel(document.getElementById('selectTriggerLevel').value);
    setTriggerLevelArg(document.getElementById('selectTriggerLevel').value);
    setProjectionPeriods(document.getElementById('selectProjectionPeriods').value);
    setProjectionPeriodsArg(document.getElementById('selectProjectionPeriods').value);
    setRiskLoading(document.getElementById('selectRiskLoading').value);
    setRiskLoadingArg(document.getElementById('selectRiskLoading').value);
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="pricing">
          <Tab eventKey="pricing" title="Pricing & Contract Terms">
            <br />
            <Table size="sm" className="table table-borderless">
              <tbody>
                <tr>
                  <td className="col-md-3"><strong>Pure Premium:</strong></td>
                  <td className="col-md-9">{"$" + formatMoney(props.dataCols.PurePremium)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Loaded Premium:</strong></td>
                  <td className="col-md-9">{"$" + formatMoney(props.dataCols.LoadedPremium)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Loading:</strong></td>
                  <td className="col-md-9">{(Number.parseFloat(props.dataCols.Loading)*100).toFixed(2) + '%'}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Discount Rate:</strong></td>
                  <td className="col-md-9">{(Number.parseFloat(props.dataCols.DiscountRate)*100).toFixed(2) + '% p.a.'}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Contract Terms:</strong></td>
                  <td className="col-md-9">
                    <p>For each month in the next <b>{projectionPeriods}</b> months when the <b>{startCase(description)} {triggerCondition} {triggerLevel} {unitOfMeasurement}</b>, 
                    the policyholder will receive a fixed payout of <b>{"$" + formatMoney(triggerPayout, 0)}</b>, paid 1 month in arrears.
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="data" title="Payout Output">
            <br />
            <DataTable dataRows={props.dataRows}/>
          </Tab>
        </Tabs>
      </div>
    );
  }
  

  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    /*  \"output\": \"[{\\\"mean\\\":493.6666666667,\\\"min\\\":0.0,\\\"median\\\":0.0,\\\"max\\\":1000.0,\\\"5th_pct\\\":0.0,\\\"95th_pct\\\":1000.0,
      \\\"disc_factor\\\":0.9991673605,\\\"pure_cashflow\\\":493.6666666667,\\\"pure_premium\\\":493.2556203164,\\\"loaded_cashflow\\\":592.4,\\\
      "loaded_premium\\\":591.9067443797,\\\"date\\\":\\\"2021-10-31\\\"} */
    const dataTableColumns = [
      {
        dataField: "date",
        text: "Date",
        sort: true
      },
      {
        dataField: "mean",
        text: "Mean ($)",
      },
      {
        dataField: "disc_factor",
        text: "Discount Factor"
      },
      {
        dataField: "pure_premium",
        text: "Pure Premium ($)"
      },     
      {
        dataField: "loaded_premium",
        text: "Loaded Premium ($)"
      }
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          // pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }


  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Price Parametric Insurance Contract</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries" name="selectTimeSeries">
                          <Form.Label>Monthly Index:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange} defaultValue="sunshine duration monthly mean daily duration|sunshine-duration-monthly-mean-daily-duration.csv">
                            <option value="" key="0">Select index...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.description + '|' + value.fileName} data-type="text">{startCase(value.description)}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectProjectionPeriods">
                          <Form.Label>Insurance Term:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select term in months...</option>
                            <option value="3">3 months</option>
                            <option value="6">6 months</option>
                            <option value="12">12 months</option>
                            <option value="24">24 months</option>
                            <option value="36">36 months</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTriggerPayout">
                          <Form.Label>Trigger Payout:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select payout in $...</option>
                            <option value="100">$100</option>
                            <option value="1000">$1,000</option>
                            <option value="10000">$10,000</option>
                            <option value="100000">$100,000</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTriggerCondition">
                          <Form.Label>Trigger Condition:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select trigger condition...</option>
                            <option value=">">greater than</option>
                            <option value="<">less than</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTriggerLevel">
                          <Form.Label>Trigger Level:</Form.Label>
                          {fileName==="sunshine-duration-monthly-mean-daily-duration.csv"? 
                            <Form.Control as="select" onChange={handleInputChange}>
                              <option value="">Select trigger level...</option>
                              <option value="3">3 hours</option>
                              <option value="4">4 hours</option>
                              <option value="5">5 hours</option>
                              <option value="6">6 hours</option>
                              <option value="7">7 hours</option>
                              <option value="8">8 hours</option>
                              <option value="9">9 hours</option>
                            </Form.Control>
                         : 
                          fileName==="surface-air-temperature-monthly-mean.csv"?
                            <Form.Control as="select" onChange={handleInputChange}>
                              <option value="">Select trigger level...</option>
                              <option value="26">26 degrees</option>
                              <option value="26.5">26.5 degrees</option>
                              <option value="27">27 degrees</option>
                              <option value="27.5">27.5 degrees</option>
                              <option value="28">28 degrees</option>
                              <option value="28.5">28.5 degrees</option>
                              <option value="29">29 degrees</option>
                            </Form.Control>
                          :
                          fileName==="rainfall-monthly-total.csv"?
                            <Form.Control as="select" onChange={handleInputChange}>
                              <option value="">Select trigger level...</option>
                              <option value="50">50 mm</option>
                              <option value="100">100 mm</option>
                              <option value="150">150 mm</option>
                              <option value="200">200 mm</option>
                              <option value="250">250 mm</option>
                              <option value="300">300 mm</option>
                              <option value="400">400 mm</option>
                              <option value="500">500 mm</option>
                              <option value="600">600 mm</option>
                              <option value="700">700 mm</option>
                            </Form.Control>
                            :
                            fileName==="rainfall-monthly-number-of-rain-days.csv"?
                              <Form.Control as="select" onChange={handleInputChange}>
                                <option value="">Select trigger level...</option>
                                <option value="5">5 days</option>
                                <option value="10">10 days</option>
                                <option value="15">15 days</option>
                                <option value="20">20 days</option>
                                <option value="25">25 days</option>
                              </Form.Control>
                            :null
                          }
                          
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectRiskLoading">
                          <Form.Label>Loading:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select loading...</option>
                            <option value=".1">10%</option>
                            <option value=".2">20%</option>
                            <option value=".3">30%</option>
                            <option value=".4">40%</option>
                            <option value=".5">50%</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                       <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                          <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                          >
                            Price
                          </LoaderButton>
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} description={description} fileName={fileName} 
                triggerPayout={triggerPayout} triggerCondition={triggerCondition} triggerLevel={triggerLevel}
                projectionPeriods={projectionPeriods} riskLoading={riskLoading}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}